import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { useNavigate, useLocation } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { Languages } from "lucide-react";

const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const isHomePage = location.pathname === "/";
  const { language, toggleLanguage, t } = useLanguage();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    if (!isHomePage) {
      navigate("/");
      setTimeout(() => {
        const element = document.getElementById(id);
        element?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      const element = document.getElementById(id);
      element?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background/98 backdrop-blur-lg shadow-premium" : "bg-transparent shadow-subtle"
      }`}
    >
      <nav className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <button 
            onClick={() => navigate("/")}
            className="text-2xl font-bold tracking-tight cursor-pointer"
            aria-label="Go to homepage"
          >
            Paulo da Silva <span className="text-primary">Pascoa Junior</span>
          </button>
          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection("about")}
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              {t("nav.about")}
            </button>
            <button
              onClick={() => scrollToSection("experience")}
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              {t("nav.experience")}
            </button>
            <button
              onClick={() => scrollToSection("certifications")}
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              {t("nav.certifications")}
            </button>
            <button
              onClick={() => scrollToSection("projects")}
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              {t("nav.projects")}
            </button>
            <button
              onClick={() => scrollToSection("skills")}
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              {t("nav.skills")}
            </button>
            <Button
              onClick={toggleLanguage}
              variant="outline"
              size="default"
              className="border-primary/40 hover:border-primary hover:shadow-glow hover:bg-primary/5 transition-all"
              title={language === "pt" ? "Switch to English" : "Mudar para Português"}
            >
              <Languages className="h-6 w-6" />
              <span className="ml-2 font-semibold">{language.toUpperCase()}</span>
            </Button>
            <Button
              onClick={() => scrollToSection("contact")}
              variant="default"
              className="gradient-accent shadow-accent"
            >
              {t("nav.contact")}
            </Button>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Navigation;
